import { TFunction } from "i18next";

import { Badge, Text } from "@pentabd/ui";

import { ViewButton } from "@components";

import { ROUTES } from "@constants/routes";

const {
  HRM: { PROVIDENT_FUND },
} = ROUTES;

export const TableColumn = (
  t: TFunction<"translation", undefined>,
  employeeID: string | number | undefined,
) => {
  return [
    {
      id: 1,
      key: "loanId",
      name: t("GPF_HISTORY.TABLE.COLUMN.LOAN_ID"),
      render: (loanId: number) => <Text color="subtitle1">{loanId}</Text>,
    },
    {
      id: 2,
      key: "loanAmount",
      name: t("GPF_HISTORY.TABLE.COLUMN.LOAN_AMOUNT"),
      render: (loanAmount: number) => (
        <Text color="subtitle1">{loanAmount}</Text>
      ),
    },
    {
      id: 3,
      key: "loanIssueDate",
      name: t("GPF_HISTORY.TABLE.COLUMN.LOAN_ISSUE_DATE"),
      render: (loanIssueDate: string) => (
        <Text color="subtitle1" className="text-nowrap">{loanIssueDate}</Text>
      ),
    },
    {
      id: 4,
      key: "isFullyPaid",
      name: t("GPF_HISTORY.TABLE.COLUMN.STATUS"),
      render: (isFullyPaid: boolean) => (
        <Badge
          label={isFullyPaid ? "Fully paid" : "Ongoing"}
          type={isFullyPaid ? "success" : "danger"}
          className="w-max"
        />
      ),
    },
    {
      id: 5,
      key: "id",
      name: "",
      render: (id: number) => (
        <ViewButton link={`${PROVIDENT_FUND}/${employeeID}/${id}`} />
      ),
    },
  ];
};
